module.exports = __webpack_public_path__ + "static/img/接诊模式@2x2.60b156fc.png";